@switch (state()) {
  @case ("idle") {
    <m-button
      type="tertiary"
      [disabled]="!lsRunId()"
      styleClass="portal-feedback-thumb"
      ariaLabel="Mark this response as helpful"
      (click)="rate(1)">
      <span class="material-symbols-outlined icon-small">thumb_up</span>
    </m-button>
    <m-button
      type="tertiary"
      [disabled]="!lsRunId()"
      styleClass="portal-feedback-thumb"
      ariaLabel="Mark this response as not helpful"
      (click)="rate(0)">
      <span class="material-symbols-outlined icon-small">thumb_down</span>
    </m-button>
  }
  @case ("loading") {
    <m-button
      type="tertiary"
      [disabled]="true"
      styleClass="portal-feedback-thumb portal-feedback-thumb--loading"
      ariaLabel="Submitting feedback">
      <span class="material-symbols-outlined icon-small animate-spin">
        progress_activity
      </span>
    </m-button>
  }
  @case ("completed") {
    <m-button
      type="tertiary"
      [disabled]="true"
      styleClass="portal-feedback-thumb portal-feedback-thumb--completed"
      ariaLabel="Feedback submitted">
      <span class="material-symbols-outlined icon-small text-blue-600">
        {{ activeIcon() }}
      </span>
    </m-button>
    <span class="b2 italic text-gray-700 ml-1"> Thanks for the feedback! </span>
  }
}
